import React, { useState, useEffect } from "react";
import { Dropdown, Menu } from 'antd';
import {
  EditOutlined,
  RightOutlined,
  UndoOutlined,
  RedoOutlined,
  ScissorOutlined,
  CopyOutlined,
  SnippetsOutlined,
  SearchOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import FileMenu from "./FileMenu";
import FormatMenu from "./FormatMenu";
import InsertMenu from "./InsertMenu";
import ViewMenu from "./ViewMenu";
import "./NavTab.css";

const editMenu = (
  <Menu className="menu-dropdown">
    <Menu.Item key="undo">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><UndoOutlined /></span>
        <span className="menu-dropdown-item-text">Undo</span>
      </span>
    </Menu.Item>
    <Menu.Item key="redo">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><RedoOutlined /></span>
        <span className="menu-dropdown-item-text">Redo</span>
      </span>
    </Menu.Item>
    <Menu.Divider />
    <Menu.Item key="cut">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><ScissorOutlined /></span>
        <span className="menu-dropdown-item-text">Cut</span>
      </span>
    </Menu.Item>
    <Menu.Item key="copy">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><CopyOutlined /></span>
        <span className="menu-dropdown-item-text">Copy</span>
      </span>
    </Menu.Item>
    <Menu.Item key="paste">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><SnippetsOutlined /></span>
        <span className="menu-dropdown-item-text">Paste</span>
      </span>
    </Menu.Item>
    <Menu.Divider />
    <Menu.Item key="find">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><SearchOutlined /></span>
        <span className="menu-dropdown-item-text">Find</span>
      </span>
    </Menu.Item>
    <Menu.Item key="replace">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><SwapOutlined /></span>
        <span className="menu-dropdown-item-text">Replace</span>
      </span>
    </Menu.Item>
  </Menu>
);

export const NavTab = () => {
  const [selectedExportType, setSelectedExportType] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="navTabContainer">
      <FileMenu
        selectedExportType={selectedExportType}
        setSelectedExportType={setSelectedExportType}
      />
      <Dropdown disabled={true} overlay={editMenu} trigger={['click']} placement={isMobile ? "rightTop" : undefined}>
        <div className="navTabItem" role="menuitem" tabIndex={0}>
          <span className="nav-tab-trigger">
            <span className="nav-tab-icon"><EditOutlined /></span>
            <span className="nav-tab-label">Edit</span>
            <span className="nav-tab-arrow"><RightOutlined /></span>
          </span>
        </div>
      </Dropdown>
      <ViewMenu />
      <InsertMenu />
      <FormatMenu />
    </div>

  );
};